import React from "react";
import { LoadingSpinner } from "@repo/ping-react-js";
import { Flex } from "@repo/ping-design";

import cx from "classnames";

import "./PingLoading.scss";

const DEFAULT_SPINNER_COLOR = "#d92f0b";

type PingLoadingProps = {
  className?: string;
  style?: React.CSSProperties;
  spinnerColor?: string;
  spinnerSize?: "xs" | "sm" | "md";
  labelClassName?: string;
};

const PingLoading = ({
  spinnerSize = "sm",
  spinnerColor = DEFAULT_SPINNER_COLOR,
  className,
  style,
  labelClassName,
}: PingLoadingProps) => {
  return (
    <Flex
      className={cx("PingLoading", className)}
      direction="column"
      align="center"
      style={style}
    >
      <LoadingSpinner size={spinnerSize} color={spinnerColor} />
      <div className={cx("PingLoading__Text", labelClassName)}>Loading</div>
    </Flex>
  );
};

export { PingLoading };
